import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';

import { OnDestroyMixin } from '@w11k/ngx-componentdestroyed';
import { LegacyTasksTabService } from '../services/tasks.service';
import { GANTT_PAPER_SIZES, Task } from '../tasks.types';

@Component({
  selector: 'gantt-pdf-export',
  templateUrl: './gantt-pdf-export.component.html',
  styleUrls: ['./gantt-pdf-export.component.scss'],
})
export class GanttPdfExportComponent extends OnDestroyMixin implements OnInit {
  public ganttPdfExportForm: UntypedFormGroup;
  public isLoading: boolean;
  paperSizes: any[];
  pageOrientations: any[] = ['Landscape', 'Portrait'];
  task: Task;
  linked_from_task_id: number;
  linked_to_task_id: number;

  constructor(
    private readonly matDialogRef: MatDialogRef<GanttPdfExportComponent>,
    private readonly formBuilder: UntypedFormBuilder,
    private _tasksService: LegacyTasksTabService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    super();
  }

  ngOnInit(): void {
    this.paperSizes = GANTT_PAPER_SIZES;
    this.buildForm();
  }

  private buildForm(): void {
    this.ganttPdfExportForm = this.formBuilder.group({
      paper_size: ['A1'],
      page_orientation: ['Landscape'],
      fit_to_width: ['yes'],
    });
  }

  // Function attached to debounce-click directive to flag the button's disable state.
  public isDebounceLoading(isLoading: boolean): boolean {
    return (this.isLoading = isLoading);
  }

  public discard(): void {
    this.matDialogRef.close();
  }

  public save(): void {
    this.matDialogRef.close({
      paper_size: this.ganttPdfExportForm.get('paper_size').value,
      page_orientation: this.ganttPdfExportForm.get('page_orientation').value,
      fit_to_width: this.ganttPdfExportForm.get('fit_to_width').value,
    });
  }
}
